module.exports = __webpack_public_path__ + "assets/events_coup_blue.f5748073.svg";